var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('textarea',{key:_vm.keyIndex,ref:"editor",attrs:{"id":_vm.keyIndex,"placeholder":_vm.placeholder}})])
}
var staticRenderFns = []

export { render, staticRenderFns }